import React from 'react';

import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';
import RichText from 'dpl/prismic/components/RichText';

export default function MagazineHeaderTitle({ title }) {
  if (!title.length) {
    return null;
  }

  return (
    <div className="PrismicMagazineHeaderTitle bb bw1 tc tl-l">
      <RichText content={title} />
    </div>
  );
}

MagazineHeaderTitle.propTypes = {
  title: StructuredTextPropTypes.isRequired
};
